<template>
    <div class="company-article">
        <dl id="dl_en" class="hide">
        <dd>We take full responsibility for every single Arivo tyre. All Arivo tyre insuranced by CCPIT.</dd>
        <dd>We are always happy to hear from our customers and to help where we can but we do ask customers to go and see our dealers if they feel they have a problem. If we receive messages via our website we will always respond but 99% of the time we will direct people to their nearest dealer who can help much better face-to-face.Around the whole world we have an extensive network of Arivo Approved Dealers who are experts when it comes to Arivo tyres and this is where we can help you at the best.</dd>
        <dd>We take any mention of potential tyre issue or failure very seriously so here’s what to do in such instances.</dd>
        <dd>Please go back to the dealer who fitted your tyres and they can help you straight away.<br/>
        If you are unsure as to who fitted your tyres, or they came with the car please find your nearest Kumho dealer by using our Dealer Locator that can be found here – Dealer Locator
Go to the dealer and explain the issue you have. They might be able to solve it right there and then for you.<br/>
        If not, and you feel there is still an issue, please ask them to begin a complaints procedure with us. They will know how to do this.<br/>
        They will notify our technical team with the details and from then on we will ensure the tyre is inspected to find out the cause of the issue.<br/>
        The tyres might be sent back to us for our technical team to review or the dealer may be able to advise us without the tyres been returned in the first instance.<br/>
        Eventually that it is found to be a manufacturing defects we will look to provide the relevant refund based on the life left in the tyre.</dd>
        <dd>Many things can contribute to these sorts of circumstances such as incorrect fitment, damaged valves, as just two examples. However, we must have the opportunity to inspect the tyre ourselves which we’re sure you can appreciate.</dd>
        </dl>
        <dl id="dl_cn" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_es" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_ru" class="hide">
            <dd>test</dd>
        </dl>
    </div>
</template>
<script>
import $ from "jquery";
import Constants from "../../consts";
import VueCookies from "vue-cookies";
import consts from "../../consts";
export default {
  name: "Warranty_Content",
  mounted: function() {
      $("#dl_en").addClass("show").removeClass("hide");
    // let lang = VueCookies.get(consts.COOKIE_LANG);
    // if (lang) {
    //   $("#dl_" + lang)
    //     .addClass("show")
    //     .removeClass("hide");
    // } else {
    //   $("#dl_en")
    //     .addClass("show")
    //     .removeClass("hide");
    // }
  }
};
</script>
<style>
.hide {
  display: none;
}
.show {
  display: block;
}
</style>




// WEBPACK FOOTER //
// src/components/service/warranty_content.vue